import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import  {motion} from 'framer-motion'
import { Cloud,  Network, Workflow } from 'lucide-react';
export default function Section3() {
  const titles = ["Multi Cloud Native Infrastructure as Code - IaC","Cloud Native Application with containers and microservices","IT Automation with DevOps & GitOps Pipelines"]
  const descriptions = ["Move to a cloud-hosted environment with a cloud-native operating model.Automate infrastructure provisioning and application configuration using IaC tools with programming and DSL-based languages.",
    "Modernize app development with microservices.Standardize delivery with Kubernetes CaaS and Multi-CaaS management, on-prem or cloud.",
    "Automate workflows across teams, tools, and infrastructure for fast app delivery.Build CI/CD pipelines for any app, any runtime, anywhere—Cloud or Edge.",
  ];
  const icon = (i) => {
    switch(i){
        case 0:
            return <Cloud className={classNames({'h-[40px] w-[40px]' : isMobile , 'h-[2.67vw] w-[2.67vw]' : !isMobile })} color="#FB923C" strokeWidth={2} />
        case 1:
            return <Workflow className={classNames({'h-[40px] w-[40px]' : isMobile , 'h-[2.67vw] w-[2.67vw]' : !isMobile })} color="#FB923C" strokeWidth={2} />
        case 2 :
            return <Network className={classNames({'h-[40px] w-[40px]' : isMobile , 'h-[2.67vw] w-[2.67vw]' : !isMobile })}   color="#FB923C" strokeWidth={2} />
        default:
            return <Cloud className={classNames({'h-[40px] w-[40px]' : isMobile , 'h-[2.67vw] w-[2.67vw]' : !isMobile })} color="#FB923C" strokeWidth={2} />
    }
  }
  const isMobile = useMediaQuery("(max-width:768px)");
  return (
    isMobile ?

    <div id="Services" className="mt-[20vh] flex flex-col gap-20 px-[10vw]">
      <h4  className=' text-center flex flex-col items-center font-bold  s:text-[2rem] xs:text-[1.75rem] text-stone-700'>
        Modernize application delivery and build an agile <br></br> IT organization—effortlessly!
      </h4>
      <div className='flex flex-col gap-8  w-full justify-between'>
        {Array.from({length:3}).map((_,i)=>(
          <div  className='border-[1px]  w-full border-stone-200   cursor-pointer hover:shadow-card bg-white transition-shadow duration-300 ease-in rounded-[16px] bg-white-200 flex p-8 flex-col gap-8'>
            <div className='flex flex-col gap-12'>
            <div className='p-3 w-fit h-fit bg-orange-200 rounded-[0.729vw] flex items-center justify-center'>{icon(i)} </div>
            <h5 className=' xs:text-[1rem] s:text-[1.5rem] font-semibold text-stone-900'>{titles[i]}</h5>
            </div>
            <div className='text-stone-700 font-medium xs:text-[0.875rem] s:text-[1.125rem]'>{descriptions[i]}</div>
          </div>
        ))}
      </div>
    </div>
    

    :
    <div id="Services" className="py-[23.70vh] flex flex-col gap-[11.851vh] px-[10vw]">
      <motion.h4 viewport={{ once: true }}  initial={{opacity:0,y:-50}} whileInView={{opacity:1,y:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className=' text-center flex flex-col items-center font-bold text-[2.1875vw] text-stone-700'>
        Modernize application delivery and build an agile <br></br> IT organization—effortlessly!
      </motion.h4>
      <div className='flex  w-full justify-between'>
        {Array.from({length:3}).map((_,i)=>(
          <motion.div key={i} viewport={{ once: true }}  initial={ i===0 ? {opacity:0, x:-50} : i===1 ? {opacity:0, y:50} : {opacity:0, x:50} } whileInView={i===0 ? {opacity:1, x:0} : i===1 ? {opacity:1, y:0} : {opacity:1, x:0} } transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='border-[1px]  max-w-[25vw]  border-stone-200   cursor-pointer hover:shadow-card bg-white transition-shadow duration-300 ease-in rounded-[1.041vw] bg-white-200 flex p-[2.962vw] flex-col gap-[2.222vh]'>
            <div className='flex flex-col gap-[4.444vw]'>
            <div className='p-[0.416vw] w-fit h-fit bg-orange-200 rounded-[0.729vw] flex items-center justify-center'>{icon(i)} </div>
            <h5 className='text-[1.145vw] font-semibold text-stone-900'>{titles[i]}</h5>
            </div>
            <div className='text-stone-700 font-medium text-[0.9375vw]'>{descriptions[i]}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}